/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/canvaseditor/shapes/RectShape',['underscore', './Shape', 'fabric'], function (_, Shape) {
	'use strict';

	var RectShape = Shape.extend({

		/**
   * Called by constructor.
   * @param options {Object} Options
   */
		init: function init(options) {
			RectShape.inherited('init', this, arguments);

			this.originalX = options.xCoord;
			this.originalY = options.yCoord;
			this.shape = new window.fabric.Rect(_.extend({}, this.defaultAttributes, {
				left: options.xCoord,
				top: options.yCoord,
				originX: 'left',
				originY: 'top',
				width: 0,
				height: 0,
				angle: 0,
				stroke: options.borderColor,
				fill: options.fillColor,
				strokeWidth: 3,
				figure: 'rect'
			}));
			options.canvas.add(this.shape);
		},

		resize: function resize(xCoord, yCoord) {
			var newProps = {
				width: this.originalX - xCoord === 0 ? this.defaultWidth : Math.abs(this.originalX - xCoord),
				height: this.originalY - yCoord === 0 ? this.defaultHeight : Math.abs(this.originalY - yCoord)
			};
			if (this.originalX > xCoord) {
				newProps.left = Math.abs(xCoord);
			}
			if (this.originalY > yCoord) {
				newProps.top = Math.abs(yCoord);
			}
			this.shape.set(newProps);
			return this.shape;
		}
	});

	RectShape.drawControlsVisibility = function (canvas, shape) {
		shape.setControlsVisibility({
			mtr: true,
			mb: true,
			mt: true,
			ml: true,
			mr: true,
			tl: true,
			br: true,
			tr: true,
			bl: true
		});
	};

	RectShape.scale = function (shape) {
		var newWidth = shape.width * shape.scaleX,
		    newHeight = shape.height * shape.scaleY;
		shape.set({
			'width': newWidth,
			'height': newHeight
		});
		shape.scale(1);
	};

	RectShape.canUpdate = function () {
		return true;
	};

	RectShape.canSkew = function () {
		return false;
	};

	RectShape.handleEnterKeyEvent = function (shape) {}; // eslint-disable-line no-unused-vars

	return RectShape;
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

